import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { StickyUrgencyBar } from './components/StickyUrgencyBar';
import { HeroSection } from './components/HeroSection';
import { HookSection } from './components/HookSection';
import { AgitationSection } from './components/AgitationSection';
import { RevelationSection } from './components/RevelationSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { OfferSection } from './components/OfferSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { ClosingSection } from './components/ClosingSection';
import { Footer } from './components/Footer';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-background text-text font-sans selection:bg-accent selection:text-background" data-id="element-0">
      <StickyUrgencyBar data-id="element-1" />
      <RecentPurchaseToast data-id="element-2" />
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <HookSection data-id="element-5" />
        <AgitationSection data-id="element-6" />
        <RevelationSection data-id="element-7" />
        <TestimonialsSection data-id="element-8" />
        <OfferSection data-id="element-9" />
        <PricingSection data-id="element-10" />
        <FAQSection data-id="element-11" />
        <GuaranteeSection data-id="element-12" />
        <ClosingSection data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
    </div>;
}